import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../shared/services/common.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { RootService } from 'src/app/shared/services/root.service';
import { ClevertapService } from '../shared/services/clevertap/clevertap.service';
import { isPlatformBrowser } from '@angular/common';
import { SeoService } from '../shared/seo/seo.service';
import { environment } from '../../environments/environment';
import { CanonicalService } from '../shared/seo/canonical.service';

declare var $: any;
@Component({
  selector: 'app-compare-product',
  templateUrl: './compare-product.component.html',
  styleUrls: ['./compare-product.component.scss']
})
export class CompareProductComponent implements OnInit {
  environment1 =environment.s3bucket.url;
  public isMobileFormVisible: boolean = false;
  lobId = "Icv-Trucks";
  sub: Subscription = new Subscription();
  selectedAccountThree: any = "";
  modelDataThree: any;
  selectedTruckBusThree: any = "";
  productDetailsDataThree: any;
  productDetailsDataOne: any;
  selectedTruckBusOne: any = "";
  selectedAccountOne: any = "";
  productDetailsDataTwo: any;
  selectedTruckBusTwo: any = "";
  selectedAccountTwo: any = "";
  performanceOne: any;
  performanceTwo: any;
  performanceThree: any;
  isTruckImage: boolean = true;
  plpplList: any = [];
  groupedArray: any = [];
  truckLobId: String = 'Icv-Trucks';
  busLobId: String = 'Buses';
  scvpickupLobId: String = 'SCVPickups';
  productDetailsData: any;
  btnName: any;
  showMenuCompare: boolean = false;
  modelDataTwo: any = [];
  modelDataOne: any;
  showDesignOne: boolean = false;
  showDesignTwo: boolean = false;
  showDesignThree: boolean = false;
  compareProductOne: any;
  compareProductTwo: any;
  compareProductThree: any;
  lobName: any;
  breadcrumbdata: any = [];
  showBreadCrumb: boolean = false;
  isUserLoggedIn: boolean = false;
  metatitle = "Tata Motors Truck & Buses Features Comparison - Tata Motors";
  metadesc = "Compare features, specifications and choose best truck or buses by Tata Motors. Know more about Tata Motors 4 wheelers On-Road price. ";
  isMobileFormVisible2: boolean;
  isMobileFormVisible3: boolean;
  DataOneArray: any=[];
  DataTwoArray: any=[];
  DataThreeArray: any = [];
  groupedArray2: any  = [];
  groupedArray3: any = [];

  constructor(private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private commonService: CommonService,
    private localStorage: secureStorage,
    private behaviorService: BehaviourSubjectService,
    private rootService: RootService, private canonicalservice: CanonicalService,
    private router: Router, private seoservice: SeoService,
    private cleverService: ClevertapService, @Inject(PLATFORM_ID) private platformId: Object) {

  }

  ngOnInit(): void {
    this.canonicalservice.createCanonicalURL('');
    this.seo();
    if (isPlatformBrowser(this.platformId)) {
      $('.header').addClass('p-scroll');
      try {
        this.cleverService.onPageView("Compare");
      } catch { }
    }

    this.sub.add(this.behaviorService.isLoggedIn.subscribe((res: any) => {
      this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
    }));
if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem('localBreadCrumb');
    this.breadcrumbdata = [];
    var breadcrumbList1 = {
      label: 'Compare',
      url: `/compare/`
    };
    this.breadcrumbdata.push(breadcrumbList1);
    this.localStorage.setItem('localBreadCrumb', JSON.stringify(this.breadcrumbdata));
    this.showBreadCrumb = true;
  }
    this.compareProductOne = this.commonService.compareVehicleOne ? this.commonService.compareVehicleOne : '';
    this.compareProductTwo = this.commonService.compareVehicleTwo ? this.commonService.compareVehicleTwo : '';
    this.compareProductThree = this.commonService.compareVehicleThree ? this.commonService.compareVehicleThree : '';
    if (this.compareProductOne?.length == 0) {

      this.lobName = 'icv trucks';
      this.selectedTruckBusOne = '';
      this.selectedTruckBusTwo = '';
      this.selectedTruckBusThree = '';
      this.getFindByDropDownsData('Icv Trucks');

    }
    else {

      this.lobName = (this.commonService?.tabSelected)?.toLowerCase();
      if (this.compareProductOne) {

        this.selectedTruckBusOne = this.compareProductOne;
        this.getTruckBusOne();
        this.getFindByDropDownsData(this.lobName);


      }
      if (this.compareProductTwo) {
        this.selectedTruckBusTwo = this.compareProductTwo;
        this.getTruckBusTwo();
      }
      if (this.compareProductThree) {
        this.selectedTruckBusThree = this.compareProductThree;
        this.getTruckBusThree();
      }
    }
  }
  compare(item: string) {
    let vcOne = null;
    let vcTwo = null;
    let vcThree = null;
    let data = {};
    this.spinner.show();

    if (item == 'One') {
      vcOne = this.productDetailsDataOne["vehicle_number"];
      data = { vc_s: [vcOne] };
    }
    else if (item == 'Two') {
      vcTwo = this.productDetailsDataTwo["vehicle_number"];
      data = { vc_s: [vcTwo] };
    }
    else if (item == 'Three') {
      vcThree = this.productDetailsDataThree["vehicle_number"];
      data = { vc_s: [vcThree] };
    }
    this.sub.add(this.apiService.getCompareList(data).subscribe({
      next: (response: any) => {

        if (response["success"]) {
          this.spinner.hide();
          if (item == 'One') {
            this.performanceOne = response["data"][0];
          }
          else if (item == 'Two') {
            this.performanceTwo = response["data"][0];
          }
          else if (item == 'Three') {
            this.performanceThree = response["data"][0];
          }

        }
        else {
          this.toastrService.warning(response.data.msg);

        }
      },
      complete: () => {
        this.spinner.hide();
      },
      error: (err) => {

        this.spinner.hide();
      }
    }));
  }

  getFindByDropDownsData(lobid: any) {
    this.lobId = lobid;
    if (lobid === this.truckLobId) {
      this.btnName = "truck";
      this.isTruckImage = true;
    }
    if (lobid === (this.busLobId)?.toLowerCase()) {
      this.btnName = "buses";
      this.isTruckImage = false;
    }
    if (lobid === this.scvpickupLobId) {
      this.btnName = "Scv Pickups";
      this.isTruckImage = false;
    }

    let jsn1 = { lob_name: lobid }
    this.sub.add(this.apiService.getDropDownList(jsn1).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.plpplList = response.data;
          let unique = [...new Set(this.plpplList.map((item: any) => item.ppl))];
          this.groupedArray = unique.map(i => ({
            name: i,
            values: this.plpplList.filter((d: any) => d.ppl === i)
          }))
          this.groupedArray2 = unique.map(i => ({
            name: i,
            values: this.plpplList.filter((d: any) => d.ppl === i)
          }))
          this.groupedArray3 = unique.map(i => ({
            name: i,
            values: this.plpplList.filter((d: any) => d.ppl === i)
          }))
          this.DataOneArray= this.groupedArray;
          this.DataTwoArray= this.groupedArray2;
          this.DataThreeArray= this.groupedArray3;
          if (isPlatformBrowser(this.platformId)) {
          this.localStorage.setItem('groupedArray2',JSON.stringify(this.groupedArray2))
          this.localStorage.setItem('groupedArray3',JSON.stringify(this.groupedArray3))
          }
        } else {
          this.plpplList = [];
        }
      },
      error: (error: any) => {
      },
      complete: () => {
      }
    })
    );
  }

  changeTab(lob: string) {
    this.isMobileFormVisible = false;
    this.isMobileFormVisible2 = false;
    this.isMobileFormVisible3 = false;

    this.performanceOne = this.performanceTwo = this.performanceThree = null;
    this.modelDataOne = this.modelDataTwo = this.modelDataThree = null;
    this.productDetailsDataOne = this.productDetailsDataTwo = this.productDetailsDataThree = null;
    this.showDesignOne = this.showDesignTwo = this.showDesignThree = false;
    this.selectedAccountOne = this.selectedAccountTwo = this.selectedAccountThree = "";
    this.selectedTruckBusOne = this.selectedTruckBusTwo = this.selectedTruckBusThree = "";
    this.getFindByDropDownsData(lob);

  }
  getItemOne(event: any) {

    let data: any = {};
    let value: any;
    this.modelDataOne = [];
    this.productDetailsDataOne = null;
    this.selectedTruckBusOne = "";

    this.plpplList.forEach(function (item: any) {
      if (item.pl == event.target.value) {
        value = item;
      }
    })
  

    data["start_row"] = 0;
    data["end_row"] = 18;
    data["lob_name"] = this.lobId ? this.lobId : "";
    data["ppl_name"] = value.ppl ? value.ppl : "";
    data["pl_name"] = value.pl ? value.pl : "";

    this.sub.add(this.apiService.getVehicleInfo(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.modelDataOne = response["data"];
        }
      },
      error: (error: any) => {
      },
      complete: () => {
      }
    })
    );
  }
  generateTwoArray(){
    if (isPlatformBrowser(this.platformId)) {
    this.groupedArray2 = JSON.parse(this.localStorage.getItem('groupedArray2'))
    }
    for(let i = 0; i < this.groupedArray2?.length; i++){
      if(this.groupedArray2[i].values?.length){
        this.DataTwoArray[i].values = this.groupedArray2[i].values.filter( item => (item.pl != this.selectedAccountOne))
      }
    }
  }
  generateThreeArray(){
    if (isPlatformBrowser(this.platformId)) {
    this.groupedArray3 = JSON.parse(this.localStorage.getItem('groupedArray3'))
    }
    for(let i = 0; i < this.groupedArray3?.length; i++){
      if(this.groupedArray3[i].values?.length){
        this.DataThreeArray[i].values = this.groupedArray3[i].values.filter( item => (item.pl != this.selectedAccountTwo && item.pl != this.selectedAccountOne))
      }
    }
  }
  getItemTwo(event: any) {
    let data: any = {};
    let value: any;
    this.modelDataTwo = [];
    this.productDetailsDataTwo = null;
    this.selectedTruckBusTwo = "";

    this.plpplList.forEach(function (item: any) {
      if (item.pl == event.target.value) {
        value = item;
      }
    })



    data["start_row"] = 0;
    data["end_row"] = 18;
    data["lob_name"] = this.lobId ? this.lobId : "";
    data["ppl_name"] = value.ppl ? value.ppl : "";
    data["pl_name"] = value.pl ? value.pl : "";

    this.sub.add(this.apiService.getVehicleInfo(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.modelDataTwo = response["data"];
        }
      },
      error: (error: any) => {
      },
      complete: () => {
      }
    })
    );
  }

  getItemThree(event: any) {
    let data: any = {};
    let value: any;
    this.modelDataThree = [];
    this.productDetailsDataThree = null;
    this.selectedTruckBusThree = "";
    this.plpplList.forEach(function (item: any) {
      if (item.pl == event.target.value) {
        value = item;
      }
    })
    data["start_row"] = 0;
    data["end_row"] = 18;
    data["lob_name"] = this.lobId ? this.lobId : "";
    data["ppl_name"] = value.ppl ? value.ppl : "";
    data["pl_name"] = value.pl ? value.pl : "";

    this.sub.add(this.apiService.getVehicleInfo(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.modelDataThree = response["data"];
        }
      },
      error: (error: any) => {
      },
      complete: () => {
      }
    })
    );
  }
  getTruckBusOne() {
    this.showMenuCompare = false;
    this.productDetailsDataOne = null;
    if (this.selectedTruckBusOne == this.selectedTruckBusTwo || this.selectedTruckBusOne == this.selectedTruckBusThree) {
      this.toastrService.warning('Choose different vehicles for comparsion');
      return
    }
    this.sub.add(this.apiService.getVehicleDetails({ product_id: this.selectedTruckBusOne }).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.productDetailsDataOne = response["data"];
          this.showDesignOne = true;
          if (this.productDetailsDataOne["images"]) {
            if (this.productDetailsDataOne["images"].image_url) {
              this.productDetailsDataOne["imageUrl"] = this.productDetailsDataOne[
                "images"
              ].image_url;
              this.productDetailsDataOne.loaded = false;
            } else {
              this.productDetailsDataOne.images
                .filter((image: any) => image.is_cover === true)
                .map((img: any) => {
                  this.productDetailsDataOne["imageUrl"] = img["image_url"];
                  this.productDetailsDataOne.loaded = false;
                });
            }
          }
          this.compare("One");
        }
      },
      error: (error: any) => {
      },
      complete: () => {
      }
    }));
  }

  getTruckBusTwo() {
    //do not remove this for testing purpose

    this.showMenuCompare = false;
    this.productDetailsDataTwo = null;
    if (this.selectedTruckBusTwo == this.selectedTruckBusOne || this.selectedTruckBusTwo == this.selectedTruckBusThree) {
      this.toastrService.warning('Choose different vehicles for comparsion');
      return
    }

    this.sub.add(this.apiService.getVehicleDetails({ product_id: this.selectedTruckBusTwo }).subscribe({
      next: (response: any) => {

        if (response["success"]) {
          this.productDetailsDataTwo = response["data"];
          this.showDesignTwo = true;
          if (this.productDetailsDataTwo["images"]) {
            if (this.productDetailsDataTwo["images"].image_url) {
              this.productDetailsDataTwo["imageUrl"] = this.productDetailsDataTwo[
                "images"
              ].image_url;
              this.productDetailsDataTwo.loaded = false;
            } else {
              this.productDetailsDataTwo.images
                .filter((image: any) => image.is_cover === true)
                .map((img: any) => {
                  this.productDetailsDataTwo["imageUrl"] = img["image_url"];
                  this.productDetailsDataTwo.loaded = false;
                });
            }
          }
          this.compare("Two");
        }
      },
      error: (error: any) => {
      },
      complete: () => {
      }
    }));
  }
  getTruckBusThree() {
    this.showMenuCompare = false;
    this.productDetailsDataThree = null;

    if (this.selectedTruckBusThree == this.selectedTruckBusOne || this.selectedTruckBusThree == this.selectedTruckBusTwo) {
      this.toastrService.warning('Choose different vehicles for comparsion');
      return
    }
    this.sub.add(this.apiService.getVehicleDetails({ product_id: this.selectedTruckBusThree }).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.productDetailsDataThree = response["data"];
          this.showDesignThree = true;
          if (this.productDetailsDataThree["images"]) {
            if (this.productDetailsDataThree["images"].image_url) {
              this.productDetailsDataThree["imageUrl"] = this.productDetailsDataThree[
                "images"
              ].image_url;
              this.productDetailsDataThree.loaded = false;
            } else {
              this.productDetailsDataThree.images
                .filter((image: any) => image.is_cover === true)
                .map((img: any) => {
                  this.productDetailsDataThree["imageUrl"] = img["image_url"];
                  this.productDetailsDataThree.loaded = false;
                });
            }
          }
          this.compare("Three");

        }
      },
      error: (error: any) => {
      },
      complete: () => {
      }
    }));
  }

  reset(item: string) {

    if (item == 'One' && this.performanceOne && (!this.performanceTwo && !this.performanceThree)) {
      this.isMobileFormVisible = false;
      this.productDetailsDataOne = null;
      this.performanceOne = null;
      this.showDesignOne = false;
      this.selectedTruckBusOne = '';
      this.selectedAccountOne = '';
    }
    else if (item == 'One') {
      this.isMobileFormVisible = false;
      this.productDetailsDataOne = null;
      this.performanceOne = null;
      this.selectedTruckBusOne = '';
      this.selectedAccountOne = '';
      this.productDetailsDataOne = this.productDetailsDataTwo;
      this.selectedAccountOne = this.selectedAccountTwo;
      this.productDetailsDataTwo = null;
      this.performanceOne = this.performanceTwo;
      this.selectedTruckBusOne = this.selectedTruckBusTwo
      this.performanceTwo = null;
      this.selectedTruckBusTwo = '';
      this.selectedAccountTwo = '';
      this.productDetailsDataTwo = this.productDetailsDataThree;
      this.selectedTruckBusTwo = this.selectedTruckBusThree
      this.productDetailsDataThree = null;
      this.performanceTwo = this.performanceThree
      if (!this.performanceTwo) {
        this.showDesignTwo = false;
      }
      this.performanceThree = null;
      this.showDesignThree = false;
      this.selectedTruckBusThree = '';

      if(this.selectedAccountThree){
        this.selectedAccountTwo = this.selectedAccountThree;
        this.selectedAccountThree = '';
      }
      else{
        this.selectedAccountThree = '';
      }

    }
    else if (item == 'Two') {
      this.isMobileFormVisible2 = false;
      this.productDetailsDataTwo = null;
      this.performanceTwo = null;
      if (!this.performanceThree) {
        this.showDesignTwo = false;

      }
      this.selectedTruckBusTwo = '';
      this.selectedAccountTwo = '';
      this.productDetailsDataTwo = this.productDetailsDataThree;
      this.selectedAccountTwo = this.selectedAccountThree;
      this.selectedTruckBusTwo = this.selectedTruckBusThree

      this.productDetailsDataThree = null;
      this.performanceTwo = this.performanceThree
      this.performanceThree = null;
      this.showDesignThree = false;
      this.selectedTruckBusThree = '';
      this.selectedAccountThree = '';
    }
    else if (item == 'Three') {
      this.isMobileFormVisible3 = false;
      this.productDetailsDataThree = null;
      this.performanceThree = null;
      this.showDesignThree = false;
      this.selectedTruckBusThree = '';
      this.selectedAccountThree = '';
    }
  }

  bookNow(item: any) {
    if (this.isUserLoggedIn) {
      let sublob = item.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (item.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : item.sub_lob.replace(/\s/g, "-")?.toLowerCase();
      let model = item.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
      this.router.navigate(['/lead-booking/' + sublob + '/' + item.lob_seo + '/' + item.ppl_seo + '/' + model + '/' + item.id]);
    }
    else {
      let sublob = item.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (item.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : item.sub_lob.replace(/\s/g, "-")?.toLowerCase();
      let model = item.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
      if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('previousUrl', '/lead-booking/' + sublob + '/' + item.lob_seo + '/' + item.ppl_seo + '/' + model + '/' + item.id)
      }
      this.router.navigate(['/login/']);
    }
    this.clevertapBook(item);
  }
  clevertapBook(productDetailsData: any) {

      try {
        this.cleverService.onBookNowButtonClick(productDetailsData["id"],
          productDetailsData["model"], productDetailsData['images'][0].image_url, "Top Navigation");
      }
      catch { }
    

  }

  seo() {
    this.seoservice.updateTitle(this.metatitle);
    this.seoservice.updateMetaTag("description", null, this.metadesc);
    this.seoservice.updateMetaTag(null, "og:locale", "en_US");
    this.seoservice.updateMetaTag(null, "og:type", "Website");
    this.seoservice.updateMetaTag(
      null,
      "og:title",
      this.metatitle
    );
    this.seoservice.updateMetaTag(null, "og:description", this.metadesc);
    this.seoservice.updateMetaTag(null, "og:url", environment.baseUrl + this.router.url);
    this.seoservice.updateMetaTag(null, "og:site_name", "Tata OSP");
  }
  public toggleMobileForm(flag): void {
    if(flag == 1){
      this.isMobileFormVisible = !this.isMobileFormVisible;
    }
    if(flag == 2){
      this.isMobileFormVisible2 = !this.isMobileFormVisible2;
    }
    if(flag == 3){
      this.isMobileFormVisible3 = !this.isMobileFormVisible3;
    }
  }
  ngOnDestroy(): void {
    this.commonService.compareVehicleOne = '';
    this.commonService.compareVehicleTwo = '';
    this.commonService.compareVehicleThree = '';
  }
}
